import { render, staticRenderFns } from "./CollectiveDetailCard.vue?vue&type=template&id=64e3b63c&scoped=true"
import script from "./CollectiveDetailCard.vue?vue&type=script&lang=js"
export * from "./CollectiveDetailCard.vue?vue&type=script&lang=js"
import style0 from "./CollectiveDetailCard.vue?vue&type=style&index=0&id=64e3b63c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3b63c",
  null
  
)

export default component.exports